<ngx-charts-bar-vertical-2d [view]="style.view" [scheme]="colorScheme" [results]="data" [gradient]="style.gradient"
  [xAxis]="style.XAxis" [yAxis]="style.YAxis" [showXAxisLabel]="style.showXAxisLabel"
  [showYAxisLabel]="style.showYAxisLabel" [xAxisLabel]="style.xAxisLabel" [yAxisLabel]="style.yAxisLabel"
  [barPadding]="style.barPadding" [legend]="style.showLegend" [legendTitle]="style.legendTitle"
  [legendPosition]="style.legendPosition" [showGridLines]="style.showGridLines" (select)="onSelect($event)"
  [showDataLabel]="style.showDataLabel">
  <ng-template #tooltipTemplate let-model="model">
    <div class="padding-6px">
      <span class="font-size-13px">{{ model?.series }} - {{ model?.name }}</span>
      <br>
      <span class="font-size-16px">{{ model?.value }}</span>
  </div>
  </ng-template>
</ngx-charts-bar-vertical-2d>